import { IState } from '../store';

export const selectIsScrollToCalculator = (state: IState): boolean => state.isScrollToCalculator;
